
<div class="widget-container" #paymentGridDiv >
  <app-hierarchical-grid-chart
    [heading]="heading"
    [headerConfig]="this.item.config?.widget_header_config"
    [config]="config"
    [item]="item"
    [pageKey]="pageKey"
    [loader]="loader"
    [selectedGroup]="selectedGroup"
    [groupDisplayType]="groupDisplayType"
    [dividerVisibility]="dividerVisibility"
    [contextMenuCondition]="contextMenuCondition"
    [detailRowAutoHeight]="detailRowAutoHeight"
    [connectingCustomDetail]="connectingCustomDetail"
    [detailComponent]="detailComponent"
    [rowData]="rowData"
    [isDetailGrid]="isDetailGrid"
    [isPivotGrid]="isPivotGrid"
    [columnDefs]="columnDefs"
    [inputConfig]="inputConfig"
    [childColumnDefs]="childColumnDefs"
    [error_name]="error_name"
    [selectedHeader]="headerWithAccountCount"
    >
  </app-hierarchical-grid-chart>
</div>